import { Notify } from "../notify";

export default () => ({
    loading: false,
    errors: {},

    form: {
        [':class']() {
            return this.loading ? 'disabled' : '';
        },

        ['@submit.prevent']() {
            this.submit();
        },
    },

    button: {
        [':disabled']() {
            return this.loading ? 'disabled' : '';
        },
    },

    async submit() {
        this.loading = true;
        const method = this.method === undefined ? 'POST' : this.method;

        const form = this.$el;
        const formData = new FormData(form);
        formData.append('lang', lang);
        const response = await fetch('/api/' + this.action, {
            method: method ,
            headers: {
                'X-csrf-token': _token
            },
            body: formData,
        });

        if (!response.ok) {
            this.errors.message = lex['form.internal_error'];
            this.loading = false;
            return;
        }

        let result = await response.json();

        this.errors = result.errors;

        if (Object.keys(this.errors).length === 0) {
            Notify.success(result.success);

            if(this.reset !== undefined) {
                form.reset();
            }
            else if(result.redirect !== undefined) {
                const timeout = result.timeout !== undefined ? result.timeout : 100;
                
                setTimeout(() => {
                    window.location = result.redirect;                    
                }, timeout);
            }
        }
        else {
            const error = result.error !== undefined ? result.error : lex['form.error'];
            Notify.error(error);
        }

        this.loading = false;
    }
})
